import Joi from "joi";

export interface UpdateClientInAssistanceAndEquipmentDTO {
    clientErpId: string | null | undefined;
    equipmentErpId: string | null;
    assistanceId: number | null;
}

export const UpdateClientInAssistanceAndEquipmentDTOSchema = Joi.object({
    equipmentErpId: Joi.string().required().messages({
        'any.required': "Equipamento é obrigatório",
        'string.base': "Equipamento é obrigatório",
        'string.empty': "Equipamento não pode estar vazio"
    }),
    clientErpId: Joi.string().required().messages({
        'any.required': "Cliente é obrigatório",
        'string.base': "Cliente é obrigatório",
        'string.empty': "Cliente não pode estar vazio"
    }),
    assistanceId: Joi.required().messages({
        'any.required': "Assistência é obrigatória"
    })
});